<xp-loading class="card flex justify-content-center" [diameter]="64" *ngIf="isLoading"></xp-loading>

<ng-container *ngIf="!isLoading">
    <div class="insights-upper-side flex flex-row">
        <div class="insights-left-block" style="width: auto">
            <div class="insights-top-header mb-4">Vehicle Performance</div>

            <operator-dashboard-date-picker
                [preset]="vehicleDatePreset"
                [startDate]="vehicleDateStart"
                [endDate]="vehicleDateEnd"
                (apply)="onVehicleDateApply($event)">
            </operator-dashboard-date-picker>

            <div class="mt-3 flex">
                <div class="insights-info-card" [ngStyle]="getPerfCardColors(RateType.Completion, vehicleStatistics?.Completion)" style="margin-right: 8px;">
                    <div class="icon-circle" [ngClass]="{'icon-good': (vehicleStatistics?.Completion >
                                            70),
                                            'icon-medium': (vehicleStatistics?.Completion <= 70 && vehicleStatistics?.Completion > 50),
                                            'icon-bad': (vehicleStatistics?.Completion <= 50)}">
                        <img class="mt-1 ml-1" src="Content/xpress-app/images/completion-{{getPerfRate(RateType.Completion, vehicleStatistics?.Completion)}}.svg" />
                    </div>
                    <div class="insights-card-percent mt-1" [ngClass]="{'percent-good': (vehicleStatistics?.Completion >
                                            70),
                                            'percent-medium': (vehicleStatistics?.Completion <= 70 && vehicleStatistics?.Completion > 50),
                                            'percent-bad': (vehicleStatistics?.Completion <= 50)}">
                        {{vehicleStatistics?.Completion}}%
                    </div>
                    <div class="insights-small-text mt-1">Completion Rate</div>
                    <div class="insights-small-text mt-1" [ngClass]="{'score-good': (vehicleStatistics?.Completion >
                                            70),
                                            'score-medium': (vehicleStatistics?.Completion <= 70 && vehicleStatistics?.Completion > 50),
                                            'score-bad': (vehicleStatistics?.Completion <= 50)}">
                        {{vehicleStatistics?.CompletedJobs}} out of {{vehicleStatistics?.AllJobs}}
                    </div>
                </div>
                <div class="insights-info-card" [ngStyle]="getPerfCardColors(RateType.Acceptance, vehicleStatistics?.Acceptance)" style="margin-right: 8px;">
                    <div class="icon-circle" [ngClass]="{'icon-good': (vehicleStatistics?.Acceptance >
                                            70),
                                            'icon-medium': (vehicleStatistics?.Acceptance <= 70 && vehicleStatistics?.Acceptance > 50),
                                            'icon-bad': (vehicleStatistics?.Acceptance <= 50)}">
                        <img class="mt-1 ml-1" src="Content/xpress-app/images/acceptance-{{getPerfRate(RateType.Acceptance, vehicleStatistics?.Acceptance)}}.svg" />
                    </div>
                    <div class="insights-card-percent mt-1" [ngClass]="{'percent-good': (vehicleStatistics?.Acceptance >
                                            70),
                                            'percent-medium': (vehicleStatistics?.Acceptance <= 70 && vehicleStatistics?.Acceptance > 50),
                                            'percent-bad': (vehicleStatistics?.Acceptance <= 50)}">
                        {{vehicleStatistics?.Acceptance}}%
                    </div>
                    <div class="insights-small-text mt-1">Acceptance Rate</div>
                    <div class="insights-small-text mt-1" [ngClass]="{'score-good': (vehicleStatistics?.Acceptance >
                                            70),
                                            'score-medium': (vehicleStatistics?.Acceptance <= 70 && vehicleStatistics?.Acceptance > 50),
                                            'score-bad': (vehicleStatistics?.Acceptance <= 50)}">
                        {{vehicleStatistics?.AcceptedJobs}} out of {{vehicleStatistics?.OfferedJobs}}
                    </div>
                </div>
                <div class="insights-info-card" [ngStyle]="getPerfCardColors(RateType.Cancellation, vehicleStatistics?.Cancellation)">
                    <div class="icon-circle" [ngClass]="{'icon-good': (vehicleStatistics?.Cancellation < 30),
                                                                         'icon-medium': (vehicleStatistics?.Cancellation >= 30 && vehicleStatistics?.Cancellation <= 50),
                                                                         'icon-bad': (vehicleStatistics?.Cancellation > 50)}">
                        <img class="mt-1 ml-1" src="Content/xpress-app/images/cancellation-{{getPerfRate(RateType.Cancellation, vehicleStatistics?.Cancellation)}}.svg" />
                    </div>
                    <div class="insights-card-percent mt-1" [ngClass]="{'percent-good': (vehicleStatistics?.Cancellation < 30),
                                                                                        'percent-medium': (vehicleStatistics?.Cancellation >= 30 && vehicleStatistics?.Cancellation <= 50),
                                                                                        'percent-bad': (vehicleStatistics?.Cancellation > 50)}">
                        {{vehicleStatistics?.Cancellation}}%</div>
                    <div class="insights-small-text mt-1">Cancellation Rate</div>
                    <div class="insights-small-text mt-1" [ngClass]="{'score-good': (vehicleStatistics?.Cancellation < 30),
                                                                                      'score-medium': (vehicleStatistics?.Cancellation >= 30 && vehicleStatistics?.Cancellation <= 50),
                                                                                      'score-bad': (vehicleStatistics?.Cancellation > 50)}">
                        {{vehicleStatistics?.CancelledJobs}} out of {{vehicleStatistics?.AllJobs}}</div>
                </div>
            </div>

            <div class="flex justify-content-between mt-3">
                <div class="driver-stats-award-item">
                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/AwesomeDriver.png" />
                    <div class="driver-stats-label-award insights-small-text">Excellent Service</div>
                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.ExcellentService]}}%</div>
                </div>
                <div class="driver-stats-award-item">
                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/ExpertNavigation.png" />
                    <div class="driver-stats-label-award insights-small-text">Expert Navigation</div>
                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.ExpertNavigation]}}%</div>
                </div>
                <div class="driver-stats-award-item">
                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/CleanCar.png" />
                    <div class="driver-stats-label-award insights-small-text">Neat and Tidy</div>
                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.NeatAndTidy]}}%</div>
                </div>
                <div class="driver-stats-award-item">
                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/ComfortableDriving.png" />
                    <div class="driver-stats-label-award insights-small-text">Great Conversation</div>
                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.GreatConversation]}}%</div>
                </div>
            </div>
            <div class="flex justify-content-between mt-2">
                <div class="driver-stats-award-item">
                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/AwesomeMusic.png" />
                    <div class="driver-stats-label-award insights-small-text">Awesome Music</div>
                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.AwesomeMusic]}}%</div>
                </div>
                <div class="driver-stats-award-item">
                    <img class="driver-stats-img-award" src="Content/xpress-app/images/cool-vehicle.svg" />
                    <div class="driver-stats-label-award insights-small-text">Cool <br />Vehicle</div>
                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.CoolCar]}}%</div>
                </div>
                <div class="driver-stats-award-item">
                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/LateNightHero.png" />
                    <div class="driver-stats-label-award insights-small-text">Late Night Hero</div>
                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.LateNightHero]}}%</div>
                </div>
                <div class="driver-stats-award-item">
                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/EntertainingDriver.png" />
                    <div class="driver-stats-label-award insights-small-text">Entertaining Driver</div>
                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.EntertainingDriver]}}%</div>
                </div>
            </div>
        </div>

        <div class="insights-right-block">
            <div class="insights-top-header mb-4">Customer Review</div>
            <div *ngIf="vehicleStatistics?.CustomerNotes?.length; else noCustomerReview">
             <xp-review class="mb-3 review-card"
                        *ngFor="let item of vehicleStatistics?.CustomerNotes"
                        [score]="item.UserMark + '.0'"
                        [date]="item.CreatedAt"
                        [text]="getMaskedReviewNote(item.ReviewUserNote)">
                <xp-rating-stars xpReviewStars
                                 class="review-stars"
                                 *ngIf="getReviewStarSrc(item.UserMark)"
                                 [rating]="item.UserMark"
                                 [filledSrc]="getReviewStarSrc(item.UserMark)"
                                 emptySrc="../Content/xpress-app/images/star-empty.svg"></xp-rating-stars>
             </xp-review>
            </div>
            <ng-template #noCustomerReview>
                <xp-empty-state class="no-review"
                                imageSrc="/XpressApp/assets/images/nocustomer-review/noreview.png"
                                description="No Reviews yet"></xp-empty-state>
            </ng-template>
        </div>
    </div>
    
    <div class="ml-3 chart-block">
        <div class="insights-top-header mt-2">Active Hours</div>
        <div class="flex mt-2">
            <div class="active-hours-font">Avg for Period:</div>
            <div class="active-hours-font ml-2">{{vehicleStatistics?.AvgHoursPerDay}} hrs per day</div>
            <div class="active-hours-font ml-auto">Total for Period:</div>
            <div class="active-hours-font ml-2 mr-auto">{{vehicleStatistics?.HoursOnline}} hours</div>
        </div>

        <div class="ml-3 mt-1">
            <xp-chart [type]="'bar'"
                      [data]="activeHoursChartData"
                      [options]="activeHoursChartOptions"
                      [height]="'21vh'">
            </xp-chart>
        </div>
    </div>
</ng-container>
